import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "../../../../Auth/_redux/authRedux";
import {
  AgentStatusOptions,
  AgentTypeOptions,
  RoleOptions
} from "./FiltersConstants";

// Slice
const initialListingsState = {
  searchColumns: [],
  callsTableFilters: {
    agentStatusOptions: AgentStatusOptions,
    roleOptions: RoleOptions,
    agentTypeOptions: AgentTypeOptions,
    selectedAgentStatus: [],
    selectedAgentStatusOptions: [],
    selectedRole: [],
    selectedRoleOptions: [],
    selectedAgentType: [],
    selectedAgentTypeOptions: [],
    selectedQueueOptions: [],
    selectedQueue: [],
  },
  appliedFiltersSelections: {},
  agentsList: [],
};

export const agentSettingsFilterSlice = createSlice({
  name: "agentSettingsFilterSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
  },

  reducers: {
    setCallsTableConfigureColumns: (state, action) => {
      state.searchColumns = action.payload;
    },
    setAgentSettingsFilters: (state, action) => {
      state.callsTableFilters = {
        ...state.callsTableFilters,
        ...action.payload["changelog"],
      };
    },

    clearLiveCallMonitorFilters: (state, action) => {
      let changelog = {};
      changelog.selectedAgentStatus = [];
      changelog.selectedRole = [];
      changelog.selectedAgentType = [];
      changelog.selectedAgentStatusOptions = [];
      changelog.selectedRoleOptions = [];
      changelog.selectedAgentTypeOptions = [];
      changelog.selectedQueue = [];
      changelog.selectedQueueOptions = [];
      state.callsTableFilters = {
        ...state.callsTableFilters,
        ...changelog,
      };
    },

    applyLiveCallsTableFilters: (state, action) => {
      var newState = { ...state.appliedFiltersSelections };
      if (action.payload["changelog"]) {
        newState["agent_status"] =
          action.payload["changelog"]["selectedAgentStatus"];
        newState["customer-status"] =
          action.payload["changelog"]["selectedAgentType"];
        newState["sip_url_flag"] =
          action.payload["changelog"]["selectedRole"];
        newState["queue_name"] = 
          action.payload["changelog"]["selectedQueue"];
      }
      state.appliedFiltersSelections = {
        ...state.appliedFiltersSelections,
        ...newState,
      };
    },

    clearLiveCallsTableAppliedFilters: (state, action) => {
      var newClearedState = { ...state.appliedFiltersSelections };
      Object.keys(newClearedState).map((key) => {
        newClearedState[key] = [];
      });
      state.appliedFiltersSelections = {
        ...state.appliedFiltersSelections,
        ...newClearedState,
      };
    },
  },
});

export const {
  setCallsTableConfigureColumns,
  setAgentSettingsFilters,
  applyLiveCallsTableFilters,
  clearLiveCallMonitorFilters,
  clearLiveCallsTableAppliedFilters,
} = agentSettingsFilterSlice.actions;
